// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1L1Di","description":"PatientConsentPreview_description__1f2KB"};